import { CsrfToken } from '@brainfocus/web/components/csrfToken/csfdToken';
import { TextInput } from '@brainfocus/web/components/text_input/text_input';
import { useState, useEffect } from 'preact/hooks';

export function Login() {
    const [showPassword, setShowPassword] = useState(false);

    // Add the Material Icons stylesheet dynamically to the head of the document
    useEffect(() => {
        const link = document.createElement('link');
        link.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&display=swap';
        link.rel = 'stylesheet';
        document.head.appendChild(link);
        document.fonts.ready.then(function () {
            const icons = document.querySelectorAll('.material-symbols-outlined');
            icons.forEach(icon => icon.classList.add('loaded'));
        });
    }, []);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    return (
        <div class='bf-ui-content'><div class='container'>
            <div class='flex-column align-items-center'>
                <h1>Welcome to BrainFocus</h1>
                {/* <p class='mb-4'>Please sign in before continuing.</p> */}
                {/*
                  * Desktop-only guidance (#869). Visibility is driven purely by the
                  * `phone-only` utility (max-width: 560px) — no user-agent sniffing,
                  * no matchMedia — so it can never block or degrade login on any
                  * device. It is advice, not a gate.
                  */}
                <p class='phone-only bf-desktop-only-notice'>
                    <strong>BrainFocus is designed for desktop.</strong> You can sign in from here,
                    but for the full experience open BrainFocus on a desktop or laptop computer —
                    the platform is not intended for use on mobile phones.
                </p>
                <form method='POST' class='d-contents'>
                    <TextInput output='string' type='email' name='email' autocomplete='username' label='E-mail'></TextInput>
                    <div class='password-input-container'>
                        <TextInput output='string' type={showPassword ? 'text' : 'password'} name='password' autocomplete='current-password' label='Password'></TextInput>
                        <button type='button' onClick={togglePasswordVisibility} class='password-toggle' aria-label='Toggle Password Visibility'>
                            <span class='material-symbols-outlined' style={{ color: 'gray', fontSize: '20px' }}>
                                {showPassword ? 'visibility_off' : 'visibility'}
                            </span>
                        </button>
                    </div>
                    <label class='bf-login-remember'>
                        <input type='checkbox' name='remember' />
                        Keep me signed in
                    </label>
                    <CsrfToken />
                    <button type='submit' class='bf-action'>Sign in</button>
                </form>

                <p class='mt-1'><a href='/reset-password'><small>Don't remember your password?</small></a></p>
            </div>
        </div></div>
    );
}
